import { checkAppPermissions } from '@repo/guards/route-checks';
import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/org/$organization/$project/$application/devops/deployment-integrations')({
    beforeLoad: async (param)=>{
        let { params, context: { queryClient } } = param;
        const can = await checkAppPermissions(queryClient, params.organization, params.project, params.application);
        if (!(can === null || can === void 0 ? void 0 : can.updateApplication)) {
            throw redirect({
                to: '/403',
                search: {
                    from: '/org/$organization/$project/$application/devops/deployment-integrations'
                }
            });
        }
    }
});
